import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
const root = window.Shopify?.routes?.root || '/';
class NoovCartView extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;this.ready=true;
    this.addEventListener('click', this.onClick);
    this.addEventListener('change',this.onChange);
    this.startTimer();
  }
  disconnectedCallback(){clearInterval(this.timer);}
  getSectionsToRender(){return [{id:'noov-cart-content'}];}
  setActiveElement(element){this.activeElement=element;}
  close(){this.closest('theme-drawer')?.close();}
  async renderContents(state){
    const html=state.sections?.['noov-cart-content'];
    if(html)this.replaceContent(html);else await this.refresh();
    await customElements.whenDefined('theme-drawer');
    this.closest('theme-drawer')?.open();
    await this.announce('add');
  }
  replaceContent(html){
    const node=new DOMParser().parseFromString(html,'text/html').querySelector('noov-cart-view');
    if(!node)throw new Error('Unable to refresh cart');
    this.className=node.className;this.innerHTML=node.innerHTML;this.startTimer();
  }
  async refresh(){
    const response=await fetch(root+'?sections=noov-cart-content');
    if(!response.ok)throw new Error('Unable to refresh cart');
    const sections=await response.json();this.replaceContent(sections['noov-cart-content']);
  }
  async announce(action,cart){
    if(!cart){const response=await fetch(root+'cart.js');if(!response.ok)return;cart=await response.json();}
    document.dispatchEvent(new CartLinesUpdateEvent({action,context:'cart',lines:[],promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'noov-drawer',didError:false}})}));
  }
  async change(line,quantity){
    if(this.busy)return;this.busy=true;this.setAttribute('aria-busy','true');
    try{
      const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:Number(line),quantity:Math.max(0,Number(quantity)),sections:['noov-cart-content']})});
      const cart=await response.json();if(!response.ok)throw new Error(cart.description||'Could not update this item.');
      this.replaceContent(cart.sections['noov-cart-content']);await this.announce('update',cart);
    }catch(error){let el=this.querySelector('.noov-cart-error');if(!el){el=document.createElement('p');el.className='noov-cart-error';el.setAttribute('role','alert');this.querySelector('.drawer__inner').prepend(el);}el.textContent=error.message;}
    finally{this.busy=false;this.removeAttribute('aria-busy');}
  }
  onClick=(event)=>{
    const remove=event.target.closest('cart-remove-button');
    if(remove){event.preventDefault();this.change(remove.dataset.index,0);return;}
    const button=event.target.closest('.quantity__button');
    if(button){event.preventDefault();const input=button.closest('quantity-input').querySelector('input');this.change(input.dataset.index,Number(input.value)+(button.name==='minus'?-1:1));}
  };
  onChange=(event)=>{if(event.target.matches('.quantity__input'))this.change(event.target.dataset.index,event.target.value);};
  startTimer(){
    clearInterval(this.timer);const el=this.querySelector('countdown-timer');if(!el)return;
    let end;
    try{end=Number(sessionStorage.getItem('noov-cart-timer-4min'));}catch(error){}
    if(!end||end<Date.now()){end=Date.now()+240000;try{sessionStorage.setItem('noov-cart-timer-4min',String(end));}catch(error){}}
    const tick=()=>{const n=Math.max(0,Math.ceil((end-Date.now())/1000));el.textContent=String(Math.floor(n/60)).padStart(2,'0')+':'+String(n%60).padStart(2,'0');if(!n)clearInterval(this.timer);};tick();this.timer=setInterval(tick,1000);
  }
}
if(!customElements.get('noov-cart-view'))customElements.define('noov-cart-view',NoovCartView);
document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
  event.promise?.then(async({detail})=>{if(detail?.source==='noov-drawer'||detail?.didError)return;const view=document.querySelector('noov-cart-view');if(!view)return;await view.refresh();if(event.action==='add')view.closest('theme-drawer')?.open();}).catch(console.error);
});
